import React, { useState } from "react";
import Header from "../Components/Header";
import PageHeader from "../Components/PageHeader";
import PhysicianProfileSidebar from "../Components/PhysicianProfileSidebar";
import DaySelector from "../Components/DaySelector";
import { Link } from "react-router-dom";
import Footer from "../Components/Footer";
import { useSelector } from "react-redux";
import { edit } from "../Constant/Index";

function Physiciantime() {
  // const Physcialtimming = useSelector(
  //   (state) => state?.Auth?.users?.operation_hour
  // );

  const Physcialtimming = useSelector((state) => state?.Auth?.operation);
  const sidb = useSelector((state) => state?.Auth?.users?.operation_hour);
  console.log(sidb, "sdickbc");

  const columns = [
    { header: "Day", field: "Day" },
    { header: "StartDate", field: "StartDate" },
    { header: "EndDate", field: "EndDate" },
  ];

  const days = {
    mon: "Monday",
    tue: "Tuesday",
    wed: "Wednesday",
    thu: "Thursday",
    fri: "Friday",
    sat: "Saturday",
    sun: "Sunday",
  };

  const daysArray = ["mon", "tue", "wed", "thu", "fri", "sat", "sun"];

  let data = [];
  for (let i = 0; i < daysArray.length; i++) {
    let slot = sidb?.filter((time) => time.day == daysArray[i]);
    // let slot = Array.isArray(Physcialtimming)
    //   ? Physcialtimming.filter((time) => time.day === daysArray[i])
    //   : [];
    data.push({
      id: i + 1,
      Day: days[daysArray[i]],
      StartDate:
        slot.length > 0 ? slot[0].formatted_start_time : "Not Availaible",
      EndDate: slot.length > 0 ? slot[0].formatted_end_time : "Not Availaible",
    });
  }

  return (
    <>
      <Header />
      <PageHeader pagename="Physician Profile" />
      <section className="main-sidebar user-profile">
        <div className="container">
          <div className="row">
            <div className="col-lg-4">
              <PhysicianProfileSidebar />
            </div>
            <div className="col-lg-8">
              <div className="main-profile-content radius-20 p-4">
                <div className="row">
                  <div className="col-md-6">
                    <div className="main-heading d-flex align-items-center gap-3 mb-3">
                      <div className="edit-btn back">
                        <div className="nav-anchor"></div>
                      </div>
                      <h5 className="main-heading level-6 main-heading-font dark-color mb-0 wow animate__animated animate__zoomIn animate__delay-1s">
                        Physician Availability
                      </h5>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div
                      style={{
                        float: "right",
                      }}
                      className="main-heading d-flex align-items-center gap-3 mb-3"
                    >
                      <div className="edit-btn back">
                        <Link to="/add-physician-availablity">
                          <div className="nav-anchor">
                            <img src={edit} alt="Edit" className="img-fluid" />
                          </div>
                        </Link>
                      </div>
                      <h5 className="main-heading level-6 main-heading-font dark-color mb-0 wow animate__animated animate__zoomIn animate__delay-1s">
                        Edit Availability
                      </h5>
                    </div>
                  </div>
                </div>
                {/* <DaySelector /> */}
                <div className="day_timming">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="table-responsive">
                        <table className="table table-striped table-bordered">
                          <thead className="thead-dark">
                            <tr>
                              {columns.map((col, index) => (
                                <th key={index}>{col.header}</th>
                              ))}
                            </tr>
                          </thead>
                          <tbody>
                            {data.length > 0 ? (
                              data.map((row, rowIndex) => (
                                <tr key={rowIndex}>
                                  {columns.map((col, colIndex) => (
                                    <td key={colIndex}>{row[col.field]}</td>
                                  ))}
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td
                                  colSpan={columns.length}
                                  className="text-center"
                                >
                                  No data available
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
}

export default Physiciantime;
